import React from "react";
import ImageWithBasePath from "../imageWithBasePath";

const TransferManual = ({ ref, handleConfirmTransfer }) => {
    return (
        <div
            ref={ref}
            className="modal fade"
            id="transfer_modal"
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header d-flex align-items-center justify-content-between">
                        <h4>Metode Pembayaran - Transfer</h4>
                        <button
                            type="button"
                            className="btn-close custom-btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <i className="isax isax-close-circle5" />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="card mb-3">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <div>
                                            <p className="mb-2">Detail Bank Kami</p>
                                            <h4 className="mb-2">1881591376</h4>
                                        </div>
                                        <h6 className="fs-16">PT. Jadi Praktisi Indonesia</h6>
                                    </div>
                                    <div className="col-6 h-100">
                                        <div className="d-flex align-items-center justify-content-end h-100">
                                            <ImageWithBasePath
                                                src="/assets/img/logo-bni.png"
                                                width={200}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mb-3">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="p-2">
                                            <ol className="ps-3" style={{ listStyle: 'auto' }}>
                                                <li className="mb-2">
                                                    Pastikan kamu sudah mengisi form sebelumnya dengan data yang benar.
                                                </li>
                                                <li className="mb-2">
                                                    Transfer sejumlah uang sesuai total yang tertera di halaman sebelumnya.
                                                </li>
                                                <li className="mb-2">
                                                    Setelah semua data terisi dan pesanan dikonfirmasi, <strong>lakukan transfer pembayaran</strong> ke rekening berikut:
                                                    <div className="mt-2 border rounded p-3 bg-light">
                                                        <p className="mb-1 fw-bold">Bank BNI</p>
                                                        <p className="mb-1">No. Rekening: <strong>1881591376</strong></p>
                                                        <p className="mb-0">Atas Nama: <strong>PT. Jadi Praktisi Indonesia</strong></p>
                                                    </div>
                                                </li>
                                                <li className="mb-2">
                                                    Setelah transfer selesai, klik tombol <strong>“Konfirmasi Pembayaran.” </strong>.
                                                </li>
                                                <li className="mb-2">
                                                    Kamu akan diarahkan ke WhatsApp dengan pesan otomatis — kirimkan pesan tersebut beserta screenshot bukti transfer.
                                                </li>
                                                <li className="mb-2">
                                                    Admin akan memverifikasi pembayaran maksimal dalam <strong>1x24 jam.</strong>.
                                                </li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="d-flex align-items-center justify-content-end m-0">
                            <button
                                type="button"
                                className="btn btn-light me-2"
                                data-bs-dismiss="modal"
                            >
                                Batal
                            </button>
                            <button
                                type="button"
                                data-bs-dismiss="modal"
                                className="btn btn-info"
                                onClick={handleConfirmTransfer}
                            >
                                Konfirmasi Pembayaran
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransferManual;
